"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOBanner = void 0;
const core_1 = require("@storyplay/core");
class DOBanner {
    constructor(rootStore, data) {
        this.bannerId = null;
        this.type = null;
        this.targetClient = null;
        this.langCode = null;
        this.storyId = null;
        this.isShow = null;
        this.title = null;
        this.content = null;
        this.linkType = null;
        this.link = null;
        this.iOSFallbackLink = null;
        this.aOSFallbackLink = null;
        this.bannerImageFile = null;
        this.willOpenAt = null;
        this.willCloseAt = null;
        this.state = null;
        this.data = null;
        this.changeSet = null;
        this.rootStore = rootStore;
        this.data = data !== null && data !== void 0 ? data : null;
        this.merge(data);
    }
    get storyByStoryId() {
        var _a, _b;
        return (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.story) !== null && _b !== void 0 ? _b : null;
    }
    get serverId() {
        var _a;
        return (_a = this.bannerId) !== null && _a !== void 0 ? _a : -1;
    }
    get bannerImageFileLink() {
        var _a, _b;
        return (_b = (_a = this.bannerImageFile) === null || _a === void 0 ? void 0 : _a.link) !== null && _b !== void 0 ? _b : null;
    }
    merge(data) {
        if (!data) {
            return this;
        }
        const fields = [
            'bannerId',
            'type',
            'location',
            'targetClient',
            'langCode',
            'storyId',
            'isShow',
            'title',
            'content',
            'linkType',
            'link',
            'iOSFallbackLink',
            'aOSFallbackLink',
            'bannerImageFile',
            'willOpenAt',
            'willCloseAt',
            'state',
        ];
        fields.forEach(name => {
            // @ts-ignore
            (0, core_1.assignIf)(data, name, v => (this[name] = v));
        });
        return this;
    }
    create(changeSet) {
        return this.rootStore.di.server.createBanner(changeSet);
    }
    update(changeSet) {
        this.changeSet = changeSet;
        if (this.serverId === -1) {
            return this.create(changeSet);
        }
        return this.rootStore.di.server.updateEntityForStudio(this, changeSet);
    }
}
exports.DOBanner = DOBanner;
